
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yxzrjufhfqviwdmhrlwq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl4enJqdWZoZnF2aXdkbWhybHdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM5NjE1NDIsImV4cCI6MjA1OTUzNzU0Mn0.YhuaoPKPm5flo_6hWFnJyukIcoYoRnNeYZyPGkpfgwc";

// Create the Supabase client with proper auth configuration
export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      storage: localStorage
    }
  }
);

// Define user role type
export type UserRole = 'user' | 'admin' | 'analyst';
